const TimeslotConstants = {
  slotArrayJa: [
    '午前0:00',
    '午前0:30',
    '午前1:00',
    '午前1:30',
    '午前2:00',
    '午前2:30',
    '午前3:00',
    '午前3:30',
    '午前4:00',
    '午前4:30',
    '午前5:00',
    '午前5:30',
    '午前6:00',
    '午前6:30',
    '午前7:00',
    '午前7:30',
    '午前8:00',
    '午前8:30',
    '午前9:00',
    '午前9:30',
    '午前10:00',
    '午前10:30',
    '午前11:00',
    '午前11:30',
    '午後0:00',
    '午後0:30',
    '午後1:00',
    '午後1:30',
    '午後2:00',
    '午後2:30',
    '午後3:00',
    '午後3:30',
    '午後4:00',
    '午後4:30',
    '午後5:00',
    '午後5:30',
    '午後6:00',
    '午後6:30',
    '午後7:00',
    '午後7:30',
    '午後8:00',
    '午後8:30',
    '午後9:00',
    '午後9:30',
    '午後10:00',
    '午後10:30',
    '午後11:00',
    '午後11:30',
    '午前0:00',
  ],
  slotArray: [
    '12:00AM',
    '12:30AM',
    '1:00AM',
    '1:30AM',
    '2:00AM',
    '2:30AM',
    '3:00AM',
    '3:30AM',
    '4:00AM',
    '4:30AM',
    '5:00AM',
    '5:30AM',
    '6:00AM',
    '6:30AM',
    '7:00AM',
    '7:30AM',
    '8:00AM',
    '8:30AM',
    '9:00AM',
    '9:30AM',
    '10:00AM',
    '10:30AM',
    '11:00AM',
    '11:30AM',
    '12:00PM',
    '12:30PM',
    '1:00PM',
    '1:30PM',
    '2:00PM',
    '2:30PM',
    '3:00PM',
    '3:30PM',
    '4:00PM',
    '4:30PM',
    '5:00PM',
    '5:30PM',
    '6:00PM',
    '6:30PM',
    '7:00PM',
    '7:30PM',
    '8:00PM',
    '8:30PM',
    '9:00PM',
    '9:30PM',
    '10:00PM',
    '10:30PM',
    '11:00PM',
    '11:30PM',
    '12:00AM',
  ],
};

export default TimeslotConstants;
